import request, { requestFile, requestV2 } from './lib/request';
import headers from './lib/headers';
import body from './lib/body';

export function getRequest(endpoint) {
  return request(endpoint, {
    headers: headers(),
  });
}

export function getFileRequest(endpoint) {
  return requestFile(endpoint, {
    headers: headers(),
  });
}

export function postRequest(endpoint, payload) {
  return request(endpoint, {
    method: 'POST',
    headers: headers(),
    body: body(payload),
  });
}

export function patchRequest(endpoint, payload) {
  return request(endpoint, {
    method: 'PATCH',
    headers: headers(),
    body: body(payload),
  });
}

export function deleteRequest(endpoint) {
  return request(endpoint, {
    method: 'DELETE',
    headers: headers(),
  });
}

export function getRequestV2(endpoint) {
  return requestV2(endpoint, {
    headers: headers(),
  });
}

export function postRequestV2(endpoint, payload) {
  return requestV2(endpoint, {
    method: 'POST',
    headers: headers(),
    body: body(payload),
  });
}

export function patchRequestV2(endpoint, payload) {
  return requestV2(endpoint, {
    method: 'PATCH',
    headers: headers(),
    body: body(payload),
  });
}

export function deleteRequestV2(endpoint) {
  return requestV2(endpoint, {
    method: 'DELETE',
    headers: headers(),
  });
}
